import { getByPathPriority } from './getByPathPriority';

const getErrorMessage = (messages, key, params) => {
    const regx = /{(.*?)}/g;
    return getByPathPriority(messages, [key], 'Ошибка валидации').replace(regx, (_, key) => getByPathPriority(params, [key], ''));
};

/**
 * Для каждого поля вернет список человекочитаемых ошибок валидации в поле `activeErrorMessages`
 *
 * @param {Object.<string, string>} messages - объект с человекочитаемым описанием ошибки
 * @param {object} validator - объект `this.$v` валидатора компонента
 */
export const extractVuelidateErrors = (messages, validator) => {
    const getErrors = () => {

        const errorsMap = {};

        const extractParams = (validatorObject, acc = {}, fieldKey = '', parentFieldKey = '') => {
            const vuelidateParams = validatorObject.$params;
            if (typeof vuelidateParams !== 'object') return acc;
            // Map all the params in the validator object. They correspond to every validation rule.
            Object.keys(vuelidateParams).forEach((paramOrFieldKey) => {
                const fieldNameFullKey = parentFieldKey ? `${parentFieldKey}.${fieldKey}` : fieldKey;

                if (typeof(validatorObject[paramOrFieldKey]) !== 'object') {
                    if (!Array.isArray(acc[fieldNameFullKey])) acc[fieldNameFullKey] = [];

                    acc[fieldNameFullKey].push({
                        paramKey: paramOrFieldKey,
                        hasError: !validatorObject[paramOrFieldKey],
                        $params: validatorObject.$params[paramOrFieldKey],
                        $dirty: validatorObject.$dirty,
                        $error: validatorObject.$error,
                        $invalid: validatorObject.$invalid,
                    });
                } else {
                    Object.entries(extractParams(validatorObject[paramOrFieldKey], acc, paramOrFieldKey, fieldNameFullKey)).forEach(([key, value]) => {
                        acc[key] = value;
                    });
                }
            });
            return acc;
        };

        extractParams(validator, errorsMap);

        return errorsMap;
    };

    const errors = getErrors();

    const getActiveErrors = () => {
        const errorsClone = { ...errors };
        Object.keys(errorsClone).map((fieldKey) => {
            errorsClone[fieldKey] = errors[fieldKey].filter((error) => error.hasError && error.$dirty);
        })
        return errorsClone;
    };

    const activeErrors = getActiveErrors();

    const getActiveErrorMessages = () => {
        const activeErrorsClone = { ...activeErrors };
        Object.keys(activeErrorsClone).map((fieldKey) => {
            activeErrorsClone[fieldKey] = activeErrors[fieldKey].map(error => ({
                key: error.paramKey,
                title: getErrorMessage(messages, error.paramKey, error.$params),
            }));
        })
        return activeErrorsClone;
    };

    return {
        errors,
        activeErrorMessages: getActiveErrorMessages(),
    };
};
